export const Logo = ({ size = 36, className = "" }) => (
  <img
    src="/logo.png"
    alt="Top Gear Performance"
    width={size}
    className={`object-contain ${className}`}
    style={{ height: "auto" }}
    data-testid="topgear-logo"
  />
);

export const BrandMark = ({ compact = false }) => (
  <div className="flex items-center" data-testid="brand-mark">
    <Logo size={compact ? 120 : 150} />
  </div>
);
